import { defineMessages } from 'react-intl';

export const MESSAGES = defineMessages({
    title: {
        defaultMessage: 'Pipeline details',
        id: 'iaso.openHexa.label.pipelineDetails',
    },
    pipelines: {
        defaultMessage: 'Pipelines',
        id: 'iaso.openHexa.label.pipelines',
    },
    confirm: {
        defaultMessage: 'Confirm',
        id: 'iaso.label.confirm',
    },
    unknownParameterType: {
        defaultMessage: 'Unknown parameter type',
        id: 'iaso.openHexalabel.unknownParameterType',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    createdAt: {
        id: 'iaso.label.created',
        defaultMessage: 'Creation',
    },
    actions: {
        id: 'iaso.label.actions',
        defaultMessage: 'Action(s)',
    },
    see: {
        defaultMessage: 'See',
        id: 'iaso.label.see',
    },
    noParameters: {
        defaultMessage: 'No parameters',
        id: 'iaso.label.noParameters',
    },
});
